export const formatNumberWithDot = (value: number | string): string => {
    const numberValue = Number(value);
    if (isNaN(numberValue)) return '0';

    const formatted = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numberValue);

    return formatted.replace(',', '.') + ' р.';
};
